/**
 * Native container shadow for the sheet card, applied via the View's
 * `nativeProps.style` — NativeWind v4 can't reliably compile a CSS box-shadow
 * to RN shadow props, so web uses the `shadow-sheet` Tailwind token while
 * native uses this raw style object (mirrors `Toast.shadows.ts`).
 *
 * Matches Figma's sheet shadow `0 2px 8px rgba(0,0,0,0.15)` (node 5456:48693).
 */
export const BOTTOM_SHEET_NATIVE_SHADOW = {
  shadowColor: '#000000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.15,
  shadowRadius: 8,
  elevation: 8,
} as const;
